import React from 'react';
import Style from './Divider.module.scss';

const Divider = () => <hr className={Style.dividerLine} />;

export default Divider;
